import * as areaState from '../buttonAreaState';
import * as toggleTags from '../toggleTags';
import * as pagination from './pagination';
import * as sort from './sort';
import * as filter from './filter';
import * as menu from '../navigation/menu';

export function rebind($context): void {
    sort.bindSort($context);
    filter.bindFilter($context);
    pagination.bindPagination($context);
    areaState.toggleAriaState($context);
    toggleTags.bindInputs($context);
    menu.wireMenuLinks();
}